import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "dd60da10-e8bc-4bbf-a9d4-7daf36fca6f6",
    content: "Cognitive performance experiments are a good example for VR experiments.",
    options: {},
  },
  {
    id: "978963d8-a568-4da1-a251-91d755a06f3e",
    content: "Immersion is not important for the experiment.",
    options: {},
  },
  {
    id: "a6423d03-b9d4-4fb5-b6bc-da07b013c081",
    content: "Environmental factors can be easier controlled in VR.",
    options: {},
  },
];

export const task: Task = {
  id: "c12e6c78-a946-42d3-8e8f-946da1b0918a",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["dd60da10-e8bc-4bbf-a9d4-7daf36fca6f6", "a6423d03-b9d4-4fb5-b6bc-da07b013c081"],
};
